<template>
  <div class="user-role-selector">
    <a href="#" @click.prevent="showSelectedOnly = !showSelectedOnly">
      {{ showSelectedOnly ? $t('show_all_units') : $t('show_only_selected_units') + ' ('+selectedDepartmentIds.length+')' }}
    </a>
    <DxDataGrid
        :data-source="filteredDepartments"
        :key-expr="'uuid'"
        show-borders
        :selection="{ mode: 'multiple' }"
        :height="400"
        :paging="{ enabled: false }"
        :scrolling="{ mode: 'virtual' }"
        @selection-changed="onSelectionChanged"
        :on-row-updated="onRowUpdated"
        :header-filter="{ visible: true }"
        ref="dataGrid"
    >
      <DxColumn
          data-field="name"
          :caption="$t('unit_name')"
          :allow-editing="false"
      >
      </DxColumn>

      <DxColumn
          data-field="role_uuid"
          caption="Role"
      >
        <DxLookup
            :data-source="local_roles"
            value-expr="uuid"
            display-expr="name"
        />
        <DxHeaderFilter
            :data-source="local_roles"
            value-expr="uuid"
            display-expr="name"
        />
      </DxColumn>

      <DxFilterRow :visible="true" />
      <DxEditing
          mode="popup"
          :allow-updating="true"
          :use-icons="true"
      />
    </DxDataGrid>

    <div class="mt-5 d-flex">
      <DxSelectBox
          :data-source="local_roles"
          display-expr="name"
          value-expr="uuid"
          v-model="bulkRoleUuid"
          :placeholder="$t('select_role_for_bulk_update')"
      />
      <button class="btn btn-primary" @click="applyBulkRole" :disabled="!selectedDepartmentIds.length">
        {{ $t('bulk_apply_role') }}
      </button>
    </div>
  </div>
</template>

<script>
import 'devextreme/dist/css/dx.light.css';
import { DxDataGrid, DxColumn, DxEditing, DxLookup, DxFilterRow, DxHeaderFilter } from 'devextreme-vue/data-grid';
import DxSelectBox from 'devextreme-vue/select-box';

export default {
  name: 'DepartmentRoleGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxSelectBox,
  },
  props: {
    user: Object,
    departments: Array,
    roles: Array,
  },
  data() {
    return {
      local_user: this.user ?? null,
      local_departments: this.departments ?? [],
      local_roles: this.roles ?? [],
      selectedDepartmentIds: [],
      bulkRoleUuid: null,
      showSelectedOnly: false,
    };
  },
  computed: {
    filteredDepartments() {
      if (this.showSelectedOnly) {
        return this.local_departments.filter(dept => this.selectedDepartmentIds.includes(dept.uuid));
      }
      return this.local_departments;
    },
  },
  methods: {
    onSelectionChanged(e) {
      this.selectedDepartmentIds = this.$refs.dataGrid.instance.getSelectedRowKeys();
      this.$emit('onChange', this.getSelectedDepartments());
    },
    getSelectedDepartments() {
      return this.local_departments.filter((item) => {
        return this.selectedDepartmentIds.includes(item.uuid)
      });
    },
    onRowUpdated(e) {
      if (e.data.role_uuid) {
        this.selectDepartment(e.data.uuid);
      } else {
        this.deselectDepartment(e.data.uuid);
      }

      this.$emit('onChange', this.getSelectedDepartments());
    },
    selectDepartment(uuid) {
      this.$refs.dataGrid.instance.selectRows([uuid], true);
    },
    deselectDepartment(uuid) {
      this.$refs.dataGrid.instance.deselectRows([uuid]);
    },
    applyBulkRole() {
      const filtered = this.local_departments.map((dept) => {
        if (this.selectedDepartmentIds.includes(dept.uuid)) {
          dept.role_uuid = this.bulkRoleUuid;
        }
        return dept;
      }).filter((item) => {
        return this.selectedDepartmentIds.includes(item.uuid)
      });

      this.$nextTick(() => {
        if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
          this.$refs.dataGrid.instance.refresh();
        }
      });

      this.$emit('onChange', filtered);
    },
  },
  watch: {
    user: {
      handler(newVal) {
        this.local_user = newVal;
      },
      immediate: true,
    },
    departments: {
      handler(newVal) {
        this.local_departments = newVal;

        this.$nextTick(() => {
          if (this.$refs.dataGrid && this.$refs.dataGrid.instance) {
            this.local_departments.forEach((item) => {
              if (item.role_uuid) {
                this.selectDepartment(item.uuid);
              }
            });
          }
        });

      },
      immediate: true,
    },
    roles: {
      handler(newVal) {
        this.local_roles = [{uuid: null, name: '-'}, ...newVal];
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>

button {
  padding: 6px 12px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
